module.exports = __webpack_public_path__ + "fonts/FuturaStd-Heavy.93dfd51b.otf";